import { Table, TableHead, TableBody, TableRow, Tooltip, IconButton, Stack, Typography } from '@mui/material';
import { GeneralTableBox, HeadTableCell, RowTableCell, LoadingSkeleton, NoDataSkeleton } from '../../../../common/components';
import { formatCurrency } from '../utils/formatters';
import { formatDate, formatDateTime } from '../../../../utils/formatUtils';
import ReceiptIcon from '@mui/icons-material/Receipt';

const DifferimentInvoicesTable = ({ rows = [], isFetching, onPrint, isPrinting }) => {
  return (
    <GeneralTableBox>
      <Table size="small">
        <TableHead>
          <TableRow>
            <HeadTableCell>Contrato</HeadTableCell>
            <HeadTableCell>Fecha</HeadTableCell>
            <HeadTableCell>Número</HeadTableCell>
            <HeadTableCell align="right">Punto de venta</HeadTableCell>
            <HeadTableCell align="right">Neto</HeadTableCell>
            <HeadTableCell align="right">IVA</HeadTableCell>
            <HeadTableCell align="right">Total</HeadTableCell>
            <HeadTableCell>CAE</HeadTableCell>
            <HeadTableCell align="center">Acciones</HeadTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {isFetching ? (
            <LoadingSkeleton />
          ) : rows.length === 0 ? (
            <NoDataSkeleton colSpan={9} message="Sin facturas" />
          ) : (
            rows.map((inv) => (
              <TableRow key={inv.uuid}>
                <RowTableCell>{inv.contract_number || '-'}</RowTableCell>
                <RowTableCell>
                  <Tooltip
                    title={
                      <Typography variant="caption">
                        {formatDateTime(inv.created_at, {
                          options: { dateStyle: 'short', timeStyle: 'medium' },
                        })}
                      </Typography>
                    }
                  >
                    <span>{formatDate(inv.created_at)}</span>
                  </Tooltip>
                </RowTableCell>
                <RowTableCell>{inv.formatted_number}</RowTableCell>
                <RowTableCell align="right">{inv.sale_point_number}</RowTableCell>
                <RowTableCell align="right">{formatCurrency(inv.net_amount)}</RowTableCell>
                <RowTableCell align="right">{formatCurrency(inv.iva_amount)}</RowTableCell>
                <RowTableCell align="right">{formatCurrency(inv.total_amount)}</RowTableCell>
                <RowTableCell>{inv.cae || 'N/A'}</RowTableCell>
                <RowTableCell align="center">
                  <Stack direction="row" spacing={1} justifyContent="center">
                    <Tooltip title="Imprimir factura">
                      <span>
                        <IconButton
                          size="small"
                          onClick={() => onPrint(inv.uuid)}
                          disabled={isPrinting}
                        >
                          <ReceiptIcon fontSize="small" />
                        </IconButton>
                      </span>
                    </Tooltip>
                  </Stack>
                </RowTableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </GeneralTableBox>
  );
};

export default DifferimentInvoicesTable;
